import React, {ChangeEvent, useState} from 'react';
import {colors} from "patient-ping-remedy/packages/theme";
import Icon, {ICONS} from "patient-ping-remedy/packages/icon";
import {StyledInput, StyledInputDiv, StyledButton} from "@common/SearchBarComponent.styles";
import {Value} from "patient-ping-remedy/packages/dropdown-list/lib/DropdownList";
import {StyleType} from "patient-ping-remedy/packages/button";
import Popover from "patient-ping-remedy/packages/popover";
import {Menu, MenuItem, MenuItemTypography} from "patient-ping-remedy/packages/menu";
import {HintTypography} from "patient-ping-remedy/packages/typography";

type Props = {
  id?: string;
  searchIcon: boolean;
  searchTerm: string;
  searchPlaceholder?: string;
  searchFunction: (searchTerm: string) => void;
  searchDropdownPlaceholder?: string;
  searchBy?: Value[];
  handleSearchByChange?: (searchBy: string) => void;
  concise?: boolean;
};

const SearchBarComponent = (props: Props) => {
  const [showPopover, setShowPopover] = useState<boolean>(false);

  function onDropdownChange(value: Value | null) {
    const val = value?.value ?? '';
    props.handleSearchByChange?.(val);
    if (val !== '') {
      props.searchFunction('');
    }
    setShowPopover(false);
  }
  function onChange(event: ChangeEvent<HTMLInputElement>) {
    event.preventDefault();
    props.searchFunction(event.target.value);
  }

  return (
    <>
      <StyledInputDiv concise={props.concise} searchBy={!!props.searchBy} data-testid={'search-bar'}>
        {props.searchIcon && (
          <Icon
            iconClass={ICONS.search}
            color={colors.purple4}
            iconSize="1x"
          />
        )}
        <StyledInput
          id={`${props.id}-search-component`}
          type="text"
          value={props.searchTerm ?? ''}
          onChange={onChange}
          placeholder={props.searchPlaceholder}
        />
        {props.searchBy && (
          <Popover
            toggle={() => setShowPopover(!showPopover)}
            isOpen={showPopover}
            position="bottom-end"
            content={
              <Menu onHide={() => setShowPopover(false)} marginTop marginBottom>
                {props.searchBy.map((item) => (
                  <MenuItem key={item.value} onClick={() => onDropdownChange(item)}>
                    <MenuItemTypography>{item.label}</MenuItemTypography>
                  </MenuItem>
                ))}
              </Menu>
            }
          >
            <StyledButton
              styleType={StyleType.TERTIARY}
              data-testid="search-by-dropdown"
              onClick={() => setShowPopover(true)}
            >
              <HintTypography>{props.searchDropdownPlaceholder}</HintTypography>
              <Icon iconClass={ICONS['angle-down']} iconSize="lg" weight="far" />
            </StyledButton>
          </Popover>
        )}
      </StyledInputDiv>
    </>
  );
};

export default React.memo(SearchBarComponent);
